import { OnboardingLargeImage } from './OnboardingLargeImage';

const OnboardingResourcesLargeImage = ({ style }) => {
  const twoX = {
    es: require('./es/onboarding-resources@2x.jpg'),
    fr: require('./fr/onboarding-resources@2x.jpg'),
    en: require('./onboarding-resources@2x.jpg')
  };
  const threeX = {
    es: require('./es/onboarding-resources@3x.jpg'),
    fr: require('./fr/onboarding-resources@3x.jpg'),
    en: require('./onboarding-resources@3x.jpg')
  };
  return (
    <OnboardingLargeImage
      oneX={twoX}
      twoX={twoX}
      threeX={threeX}
      style={style}
    />
  );
};

export { OnboardingResourcesLargeImage };
